import { accountingTasksService } from "../accountingTasksService";
import { accountingTaskReducerActions } from "../../../../_services/store";
import { ExportType } from "../../ExportStatics";

export const getAllAccountingTasks = (filterProperties, clearItems = true) => {
    return async (dispatch) => {
        dispatch(accountingTaskReducerActions.getAllAccountingTasksRequest(filterProperties));
        try {
            const accountingTasks = await accountingTasksService.getAllAccountingTasks(filterProperties);
            dispatch(accountingTaskReducerActions.getAllAccountingTasksSuccess(accountingTasks));
            return accountingTasks;
        } catch (error) {
            // "Die Buchungsstapel konnten nicht abgerufen werden. Bitte versuche es später erneut."
            dispatch(
                accountingTaskReducerActions.getAllAccountingTasksFailure({
                    errorMessage: error,
                    clearItems: clearItems,
                })
            );
            return error;
        }
    };
};

export const toggleAccountingTaskDeletionModal = () => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.toggleAccountingTaskDeletionModal());
    };
};

export const deleteAccountingTask = (list, filterProperties) => {
    return async (dispatch) => {
        dispatch(accountingTaskReducerActions.deleteAccountingTaskRequest());
        try {
            await accountingTasksService.deleteAccountingTask(list);
            dispatch(accountingTaskReducerActions.deleteAccountingTaskSuccess());
            return await dispatch(getAllAccountingTasks(filterProperties));
        } catch (error) {
            dispatch(accountingTaskReducerActions.deleteAccountingTaskFailure(error));
            return error;
        }
    };
};

export const loadAccountingTaskDetails = (externalUUID) => {
    return async (dispatch) => {
        dispatch(accountingTaskReducerActions.getAccountingTaskDetailsRequest());
        try {
            const taskDetails = await accountingTasksService.getAccountingTaskDetails(externalUUID);
            if (taskDetails) {
                dispatch(accountingTaskReducerActions.getAccountingTaskDetailsSuccess(taskDetails));
            } else {
                dispatch(
                    accountingTaskReducerActions.getAccountingTaskDetailsFailure(
                        "Falscher Link. Buchungsstapel konnte nicht gefunden werden"
                    )
                );
            }
        } catch (error) {
            dispatch(accountingTaskReducerActions.getAccountingTaskDetailsFailure(error));
            return error;
        }
    };
};

export const toggleCsvExportModal = () => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.toggleCsvExportModal());
    };
};

export const exportAccountingTaskAsCSV = (exportRequest) => {
    return async (dispatch) => {
        try {
            const exportResponse = await accountingTasksService.exportAccountingTasks(exportRequest);
            const downloadUrl = exportResponse.externalUUID
                ? process.env.REACT_APP_API_BASE_URL + "/download/" + exportResponse.externalUUID
                : exportResponse.fileName;
            downloadFile(downloadUrl, exportResponse.filename);
            dispatch(accountingTaskReducerActions.exportAccountingTaskAsCSVSuccess(exportResponse));
            return exportResponse;
        } catch (error) {
            dispatch(accountingTaskReducerActions.exportAccountingTaskAsCSVFailure(error));
            throw error;
        }
    };
};

export const exportDuplicatesForAccountingTask = (request) => {
    return async (dispatch) => {
        try {
            dispatch(accountingTaskReducerActions.exportDuplicatesForAccountingTaskRequest());
            const exportResponse = await accountingTasksService.exportDuplicatesForAccountingTask(request);
            const downloadUrl = process.env.REACT_APP_API_BASE_URL + "/download/" + exportResponse.externalUUID;
            downloadFile(downloadUrl, exportResponse.filename);
            dispatch(accountingTaskReducerActions.exportDuplicatesForAccountingTaskSuccess(exportResponse));
            return exportResponse;
        } catch (error) {
            dispatch(accountingTaskReducerActions.exportDuplicatesForAccountingTaskFailure(error));
            throw error;
        }
    };
};

export const downloadFile = (url, filename) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "Downloaden";
    document.body.appendChild(a);
    a.click();
    a.parentNode.removeChild(a);
};

export const toggleXmlExportModal = () => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.toggleXmlExportModal());
    };
};

export const exportAccountingTaskAsXML = (exportRequest) => {
    return async (dispatch) => {
        dispatch(accountingTaskReducerActions.exportAccountingTaskAsXMLRequest());
        try {
            const exportResponse = await accountingTasksService.exportAccountingTasks(exportRequest);
            dispatch(accountingTaskReducerActions.exportAccountingTaskAsXMLSuccess(exportResponse));
            return exportResponse;
        } catch (error) {
            dispatch(accountingTaskReducerActions.exportAccountingTaskAsXMLFailure(error));
            return error;
        }
    };
};

export const toggleDatevUOExportModal = () => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.toggleDatevUOExportModal());
    };
};

export const exportAccountingTaskToDatevUO = (exportRequest) => {
    return async (dispatch) => {
        dispatch(accountingTaskReducerActions.exportAccountingTaskToDatevUORequest());
        try {
            const exportResponse = await accountingTasksService.exportAccountingTasks(exportRequest);
            dispatch(accountingTaskReducerActions.exportAccountingTaskToDatevUOSuccess(exportResponse));
            return exportResponse;
        } catch (error) {
            dispatch(accountingTaskReducerActions.exportAccountingTaskToDatevUOFailure(error));
            throw error;
        }
    };
};

export const triggerNavisionExcelExport = (taskUUID) => {
    // Using the existing call for .CSV as there is no difference from the backend perspective.
    return async (dispatch) =>
        dispatch(
            exportAccountingTaskAsCSV({
                exportType: ExportType.NAVISION,
                includeDocuments: true,
                tasks: [taskUUID],
            })
        );
};

export const triggerSAPExcelExport = (taskUUID) => {
    // Using the existing call for .CSV as there is no difference from the backend perspective.
    return async (dispatch) =>
        dispatch(
            exportAccountingTaskAsCSV({
                exportType: ExportType.SAP,
                includeDocuments: true,
                tasks: [taskUUID],
            })
        );
};

export const toggleDuplicatesExportModal = (request) => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.toggleDuplicatesExportModal(request));
    };
};

export const handleDuplicatesExportRequestChange = (request) => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.handleDuplicatesExportRequestChange(request));
    };
};

export const toggleDownloadLinkModal = () => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.toggleAccountingTaskDownloadModal());
    };
};

export const clearDetailsReferrer = () => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.clearDetailsReferrer());
    };
};

export const clearAccountingTasks = () => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.clearAccountingTasks());
    };
};

export const compressAccountingTasks = (taskUUIDs) => {
    return async (dispatch) => {
        dispatch(accountingTaskReducerActions.compressAccountingTasksRequest());
        try {
            await accountingTasksService.compressAccountingTasks(taskUUIDs);
            dispatch(accountingTaskReducerActions.compressAccountingTasksSuccess());
        } catch (error) {
            dispatch(accountingTaskReducerActions.compressAccountingTasksFailure(error));
            throw error;
        }
    };
};

export const setModalErrorMessage = (errorMessage) => {
    return (dispatch) => {
        dispatch(accountingTaskReducerActions.setAccountingTaskExportModalErrorMessage(errorMessage));
    };
};

export const loadAccountingTaskSummary = (externalUUID) => {
    return async (dispatch) => {
        dispatch(accountingTaskReducerActions.getAccountingTaskSummaryRequest());
        try {
            const summary = await accountingTasksService.getAccountingTaskSummary(externalUUID);
            dispatch(accountingTaskReducerActions.getAccountingTaskSummarySuccess(summary));
            return summary;
        } catch (error) {
            dispatch(accountingTaskReducerActions.getAccountingTaskSummaryFailure(error));
            return error;
        }
    };
};
